import LazyLoadImageComponent from "core/components/LazyLoadImage";
import { useGetCoupang } from "core/hooks/useGetCoupang";
import { _t } from "core/language";
import { numberFormatCurrency } from "core/utils/helper";
import MainNodata from "modules/Main/components/NodataComponent";
import { useEffect, useState } from "react";
import LogoRocket from "../../../../core/assets/images/logo_rocket_large.png";
import RecipeCoupangLoading from "./loading";

interface IngredientCoupangProps {
  keyword: string[];
  title: string;
}

const IngredientCoupang = ({ keyword, title }: IngredientCoupangProps) => {
  const keywordLength = 50;

  const _keyword =
    Array.isArray(keyword) && keyword.length > 0
      ? keyword.join(",").substring(0, keywordLength)
      : "";

    
  const [params, setParams] = useState<any>({
    keyword: _keyword,
    limit: 10,
  });

  useEffect(() => {
    setParams({
      ...params,
      keyword: _keyword,
    });
  }, [keyword.length]);

  const { data, loading } = useGetCoupang(params);

  const openUrl = (url: string) => {
    (window as any).webViewOpenBrowser(url);
  };

  const hasData = data?.productData?.length > 0;

  return (
    <div>
      <h3 className="text-[#111111] text-[16px] font-medium pl-4 mb-4">
        {title}
      </h3>
      {/* <h2 className="text-[#111111] text-[16px] font-medium pl-4 mb-4">
        <p>Keywords: {_keyword}</p>
        <p>lengh: {_keyword.length}</p>
      </h2> */}
      <ul className="flex overflow-x-auto no-scrollbar px-2">
        {loading && !hasData && <RecipeCoupangLoading />}
        {(data?.productData || []).map((item: any, index: number) => {
          return (
            <li
              key={index}
              className="px-2 cursor-pointer"
              onClick={() => openUrl(item.productUrl)}
            >
              <div className="min-w-[120px] max-w-[120px] h-[120px]">
                <LazyLoadImageComponent
                  src={item.productImage}
                  alt={item.productName}
                />
              </div>
              <p className="text-xs font-medium mt-2 ">{item.productName}</p>
              <p className="text-xs text-red-500 mt-1">
                {numberFormatCurrency(+item?.productPrice, ',', 2)} 원
                {/* curren */}
              </p>
              <div className="w-[64px] h-4 mt-1">
                <img src={LogoRocket} alt="" />
              </div>
            </li>
          );
        })}
        <MainNodata
          loading={loading}
          data={data?.productData || []}
          text={_t("main.no_data")}
        />
      </ul>
    </div>
  );
};

export default IngredientCoupang;
